import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { ContainerState, RequestDealersPayload } from './types';
import { getAgentType } from 'app/utils/agentType';

// The initial state of the header container
export const initialState: ContainerState = {
  dealers: { data: {}, loading: false, error: null },
  selectedDealer: 'default',
  isDealerSelectEnabled: true,
  isDrawerOpen: false,
  // Hydrate from localStorage so the selection persists across reloads.
  selectedAgentType: getAgentType(),
};

const headerSlice = createSlice({
  name: 'headerState',
  initialState,
  reducers: {
    requestDealers: {
      reducer(
        state,
        action: PayloadAction<RequestDealersPayload | undefined>,
      ) {
        state.dealers.loading = true;
        state.dealers.error = null;
      },
      prepare(payload?: RequestDealersPayload) {
        return { payload };
      },
    },
    requestDealersSuccess(state, action: PayloadAction<any>) {
      state.dealers.data = action.payload;
      state.dealers.loading = false;
    },
    requestDealersError(state, action: PayloadAction<any>) {
      state.dealers.error = action.payload;
      state.dealers.loading = false;
    },
    selectDealer(state, action: PayloadAction<any>) {
      state.selectedDealer = action.payload;
    },
    toggleDealerSelect(state, action: PayloadAction<any>) {
      state.isDealerSelectEnabled = action.payload;
    },
    setDealer(_state, _action: PayloadAction<any>) {
      // Dealer resolution is handled asynchronously in header saga.
    },
    setDrawerOpen(state, action: PayloadAction<any>) {
      state.isDrawerOpen = action.payload || false
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.dealers.loading = action.payload;
    },
    setSelectedAgentType(state, action: PayloadAction<string | null>) {
      state.selectedAgentType = action.payload || null;
    },
  },
});

export const { actions: headerActions, reducer, name: sliceKey } = headerSlice;
